(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-share"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element ? event.target.closest('.product-share') : null;
    if (!(button instanceof HTMLElement)) return;

    const url = button.dataset.shareUrl || window.location.href;
    const title = button.dataset.shareTitle || document.title;

    if (navigator.share) {
      try {
        await navigator.share({ title, url });
      } catch (error) {
        // The user closed the share sheet; nothing to do.
      }
      return;
    }

    const status = button.querySelector('.product-share__status');
    try {
      await navigator.clipboard.writeText(url);
    } catch (error) {
      return;
    }
    if (!status) return;

    status.textContent = button.dataset.copiedLabel || '';
    status.classList.add('is-visible');
    window.setTimeout(() => status.classList.remove('is-visible'), 2000);
  });
  } catch(e) { console.error(e); }
})();

})();
